import { camelCase, slugify } from '@basehub/utils/case/index'

const numToWord: Record<string, string> = {
  '0': 'zero',
  '1': 'one',
  '2': 'two',
  '3': 'three',
  '4': 'four',
  '5': 'five',
  '6': 'six',
  '7': 'seven',
  '8': 'eight',
  '9': 'nine',
}

const replaceNumberWithWord = (str: string) => {
  return str.replace(/^\d/, (match) => {
    return numToWord[match] as string
  })
}

export const getApiNameFromTitle = (
  title: string,
  defaultTitle = 'Untitled'
): string => {
  const processed = replaceNumberWithWord(camelCase(title))
  if (!processed) {
    if (defaultTitle === '') return defaultTitle
    // if for example it comes empty, because `camelCase` stripped special characters
    // or client directly sent an empty title
    return getApiNameFromTitle(defaultTitle)
  }
  return processed
}

export const getSlugFromTitle = (title: string): string => {
  if (title === '') return title
  const processed = slugify(title)
  if (!processed) {
    // if for example it comes empty, because `camelCase` stripped special characters
    // or client directly sent an empty title
    return getSlugFromTitle('') // slugs support ""
  }
  return processed
}

export const getApiNameWithoutCollisions = (
  id: string,
  title: string,
  existingItems: Set<string>
) => {
  const apiName = getApiNameFromTitle(title)

  const candidate = apiName
  const buildSuffix = (i: number) => {
    if (i === 0) return '' // first try as is
    if (i <= 50) return `_${i}` // try with index for most cases
    return `_${id}` // fall back to short id
  }
  let i = 0
  while (existingItems.has(candidate + buildSuffix(i))) {
    i++
  }

  return candidate + buildSuffix(i)
}

export const getApiSlugWithoutCollisions = (
  id: string,
  title: string,
  existingItems: Set<string>
) => {
  const slug = getSlugFromTitle(title)
  const suffixWithLeadingDash = slug !== ''

  const candidate = slug
  const buildSuffix = (i: number, withLeadingDash: boolean) => {
    if (i === 0 && slug !== '') return '' // first try and slug is non-empty, we leave it as is
    return `${withLeadingDash ? '-' : ''}${id}` // fall back to id
  }
  let i = 0
  while (existingItems.has(candidate + buildSuffix(i, suffixWithLeadingDash))) {
    i++

    if (i > 100) {
      console.error('errored while getting slug for', id)
      throw new Error('Too many slug collisions. This must be a bug...')
    }
  }

  return candidate + buildSuffix(i, suffixWithLeadingDash)
}
